<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import Our_Gallery from "@/assets/json/our-gallery.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      Our_Gallery: Our_Gallery,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
<template>
  <div class="accordion-item mb-0">
    <div class="accordion-header" id="accordion-headingSeven">
      <div
        class="accordion-button p-0"
        data-bs-toggle="collapse"
        data-bs-target="#accordion-collapseSeven"
        aria-expanded="true"
        aria-controls="accordion-collapseSeven"
        role="button"
      >
        Gallery
      </div>
    </div>
    <div
      id="accordion-collapseSeven"
      class="accordion-collapse collapse show"
      aria-labelledby="accordion-headingSeven"
    >
      <div class="accordion-body p-0 border-0 mt-3 pb-1">
        <div class="provider-gallery-slider owl-carousel custom-owl-dot">
          <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
            <Slide v-for="item in Our_Gallery" :key="item.id">
              <img
                :src="require(`@/assets/img/gallery/${item.Image}`)"
                class="rounded"
                alt="img"
              />
            </Slide>
            <template #addons>
              <Navigation />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
</template>
